import type { QueryClient } from "@tanstack/react-query";
import { toClassSearchBody } from "@/features/classes/shared/classFilters";
import { ClassesApi, type SearchQueryRequest } from "@/openapi/generated";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";

export async function prefetchClassesGetAdmin(
  queryClient: QueryClient,
  page: number = 1,
  pageSize: number = 30,
  lastSelectedId?: number | null,
  active?: boolean,
  accessToken?: string,
  searchQueryRequest: SearchQueryRequest | null = null,
) {
  if (!accessToken) {
    throw new Error("Access token is required for prefetching classes");
  }

  const searchBody = toClassSearchBody(searchQueryRequest);
  const service = createAuthenticatedApi(ClassesApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [
      QueryKeys.Classes,
      "search",
      page,
      pageSize,
      lastSelectedId,
      active,
      searchQueryRequest,
    ],
    queryFn: async () =>
      service.apiClassesSearchPost({
        page,
        pageSize,
        lastSelectedId: lastSelectedId ?? undefined,
        active,
        searchQueryRequest: searchBody,
      }),
  });

  return queryClient;
}
